import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { register } from 'swiper/element/bundle';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './home.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class Home {
  private portalUrl = environment.portalUrl;
  private practicasUrl = environment.practicasUrl;

  readonly images = ['assets/images/banners/fondo.webp'];
  constructor(private router: Router) {
    register();
  }
  goSolicitarTurno() {
    this.router.navigate(['/busqueda']);
  }
  goConsultarTurno() {
    this.router.navigate(['/consulta-turnos']);
  }
  goTurnosPracticas() {
    window.open(this.practicasUrl, '_blank');
  }
  goPortalPaciente() {
    window.open(this.portalUrl, '_blank');
  }
}
